<template>
  <div
    v-if="location !== '/privacy-policy' && isDesktop"
    :class="[isSidebarOpen ? 'hidden lg:flex lg:w-[340px]' : 'w-[75px]']"
    class="min-h-screen transition-300 shrink-0"
  />
  <div
    v-if="location !== '/privacy-policy'"
    :class="[
      isMobile
        ? isSidebarOpen
          ? 'translate-x-0 w-full'
          : 'translate-x-[-100%]'
        : isSidebarOpen
          ? 'w-[340px]'
          : 'w-[75px]',
    ]"
    class="min-h-screen bg-white-100 transition-300 fixed flex flex-col justify-start z-[30] h-full overflow-hidden"
  >
    <div>
      <div
        class="bg-white-100 w-full px-[34px] z-10 py-5 flex items-center justify-between border-b border-solid border-white/30"
      >
        <div
          :class="{ 'translate-x-[-350px]': !isSidebarOpen }"
          class="relative overflow-hidden transition-300 w-[160px]"
        >
          <RouterLink to="/">
            <img src="/logo/saraf-logo-dark.svg" alt="Saraf Logo" />
          </RouterLink>
        </div>
        <div
          class="cursor-pointer w-6 h-6 flex items-center justify-center transition-300"
          @click="toggleSidebar"
        >
          <span class="flex items-center transition-300">
            <i
              v-if="isMobile"
              class="icon-grid text-xl font-semibold flex items-center leading-130 !text-dark !opacity-100 mr-3"
            />
            <i
              v-else
              :class="{ '!text-dark !opacity-100 mr-3': !isSidebarOpen }"
              class="icon-grid text-xl text-gray-450 opacity-50 font-semibold flex items-center leading-130 hover:text-dark hover:opacity-100"
            />
          </span>
        </div>
      </div>
    </div>
    <div
      class="no-scrollbar h-full overflow-y-auto scroll-smooth flex flex-col justify-between"
    >
      <CMenuList :is-open="isSidebarOpen" :location="location" />
      <div
        class="px-5 pb-5 transition-300"
        :class="{ 'translate-x-[-350px]': !isSidebarOpen }"
      >
        <CPlanCard
          @checkUserStopReason="handleCheckUserStopReason"
          :loading="reasonLoading"
        />
        <RouterLink
          class="text-sm underline text-gray-450 hover:text-green transition-300"
          :to="`/${staticPages?.[0]?.slug}`"
        >
          {{ $t("saraf_terms_and_conditions") }}
        </RouterLink>
        <p class="text-sm text-gray-450 mt-2.5">
          {{ $t("version") }} {{ CONFIG.APP_VERSION }}
        </p>
      </div>
    </div>
    <BuyStopReason
      :loading="activateLoading"
      :show="showReason"
      :type="reasonType"
      @close="showReason = false"
      @activateBots="handleActivateBots"
    />
  </div>
</template>

<script lang="ts" setup>
import { computed, onMounted, ref } from "vue";
import { useRoute } from "vue-router";
import { CONFIG } from "@/config";
import { useCommonStore } from "@/modules/Pages/stores";
import { useMobile } from "@/composables/useMobile";
import CPlanCard from "@/layout/Dashboard/components/CPlanCard.vue";
import CMenuList from "@/layout/Dashboard/components/CMenuList.vue";
import BuyStopReason from "@/components/Common/Dialog/BuyStopReason.vue";
import ApiService from "@/services/ApiService";
const { showToast } = useCustomToast();
import { useCustomToast } from "@/composables/useCustomToast";
import { useI18n } from "vue-i18n";

const isSidebarOpen = computed(() => commonStore.isSidebarOpen);
const route = useRoute();
const { isMobile } = useMobile("mobile");
const { isDesktop } = useMobile("desktop");

const { t } = useI18n();

const showReason = ref(false);
const reasonLoading = ref(false);
const activateLoading = ref(false);
const reasonType = ref("plan");
const commonStore = useCommonStore();
const location = computed(() => route.path);
const staticPages = computed(() => commonStore.data?.results);

const toggleSidebar = () => {
  commonStore.isSidebarOpen = !commonStore.isSidebarOpen;
  localStorage.setItem("isSidebarOpen", String(isSidebarOpen));

  if (!isSidebarOpen.value) {
    commonStore.isSidebarOpen = false;
  }

  if (isMobile.value && isSidebarOpen.value) {
    document.body.style.overflow = "hidden";
  } else {
    document.body.style.overflow = "";
  }
};
if (window.innerWidth > 1280) {
  commonStore.isSidebarOpen = JSON.parse(
    JSON.stringify(localStorage.getItem("isSidebarOpen")),
  );
}

const handleCheckUserStopReason = () => {
  reasonLoading.value = true;
  ApiService.get("user/is-stop-buy-reason/")
    .then((res) => {
      if (res?.data?.is_stop_buy_reason === null) {
        reasonType.value = "success";
      }
      if (res?.data?.is_stop_buy_reason === "balance") {
        reasonType.value = "balance";
      }
      if (res?.data?.is_stop_buy_reason === "plan") {
        reasonType.value = "plan";
      }
      showReason.value = true;
    })
    .finally(() => {
      reasonLoading.value = false;
    });
};
const handleActivateBots = () => {
  activateLoading.value = true;
  ApiService.get("/user/activate-bots/")
    .then(() => {
      showToast(t("bot_activated"), "success");
      showReason.value = false;
    })
    .finally(() => {
      activateLoading.value = false;
    });
};
onMounted(() => {
  // if (useMobile("desktop")) {
  // Update isOpen on window resize
  window.addEventListener("resize", () => {
    if (window.innerWidth <= 1280) {
      commonStore.isSidebarOpen = false;
    } else {
      commonStore.isSidebarOpen = true;
    }
    localStorage.setItem("isSidebarOpen", String(isSidebarOpen.value));
  });
  commonStore.isSidebarOpen = window.innerWidth >= 1280;
  // } else {
  //   commonStore.isSidebarOpen = false;
  // }
});
</script>
<style scoped>
.sidebar-scroll {
}
</style>
